import { useContext } from 'react'

import { LoadBoardContext } from 'legacy/contexts/loadBoard'

import { type BidLoad } from '../../domain/Bid'
import { mapApiToBid } from '../../infra/bidMapper'

export function useActiveBid(load?: Partial<BidLoad>) {
  const [{ bids }] = useContext(LoadBoardContext)

  const activeBid = load?.uuid && bids?.[load.uuid]

  return activeBid ? mapApiToBid(activeBid) : null
}
